//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'
import { getBestBetweenTwoPromos, sortPromos } from '@/scripts/libs/sort-promos'
import Rb3dProductPrices from './rb-3d-product-prices.vue'
import wcs from '@/scripts/libs/wcs'
import Images from '@/scripts/libs/images'
import { mapGetters } from 'vuex'

export default {
  name: 'rb-3d-product',
  components: {
    'rb-3d-product-prices': Rb3dProductPrices,
    RbBanner,
  },
  props: {
    wcsProduct: {
      type: Object,
      default: () => ({}),
    },
    backgroundColor: {
      type: String,
      default: 'white',
    },
    isDummyBanner: {
      type: Boolean,
      default: false,
    },
    imageAlt: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['translation']),
    product() {
      const product = this.wcsProduct?.colors[0]
      return product
    },
    prices() {
      const product = this.product
      const promotions = sortPromos(this.product.priceArray)
      const currentPromotion = getBestBetweenTwoPromos(promotions)
      return {
        original: product.offerPrice,
        discounted: currentPromotion?.priceLabel,
        badge: currentPromotion?.badge,
      }
    },
    image() {
      const { pdp } = wcs.getStoreConfig()
      const productImage = `${pdp.imagesPath}${this.product.partNumber}__STD__shad__cfr.png`
      return Images.get3dProductImage(this.$mq, productImage, this.backgroundColor)
    },
    dataDescription() {
      return this.wcsProduct?.colors[0].modelName + '_' + this.wcsProduct?.colors[0].partNumber
    },
  },
}
